module.exports = __webpack_public_path__ + "static/media/_MIC2662.image.3591a4e0.png";